export interface ContactFormData {
  discipline: string;
  message: string;
  name: string;
  email: string;
  entityId: string;
}

export type DisciplineType =
  | "Investor"
  | "Architect"
  | "Consultant"
  | "Contractor"
  | "Engineer"
  | "Other";

export interface ContactFormEvent {
  formData: ContactFormData;
  source?: string;
}

export interface ContactFormErrors {
  discipline?: string;
  message?: string;
  name?: string;
  email?: string;
  general?: string;
}

export const DISCIPLINE_OPTIONS: DisciplineType[] = [
  "Investor",
  "Architect",
  "Consultant",
  "Contractor",
  "Engineer",
  "Other"
];